// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3052":"82209f07","7084":"a6c345c5"}[chunkId] + ".chunk.css";
};